import React, { memo, forwardRef, useImperativeHandle, useRef, useMemo } from 'react';
import { Form, Input } from 'antd';
import { Formik, FormikProps } from 'formik';
import * as yup from 'yup';

const validationSchema = yup.object().shape({
  name: yup.string().required('Заавал оруулна'),
  source: yup.string().required('Заавал оруулна'),
  sourceUrl: yup.string().required('Заавал оруулна'),
});

type FormValues = {
  name: string | undefined;
  nameEng: string | undefined;
};

type Props = {
  onSubmit: (values: any) => void;
  action: any;
};

export type BrandFormRef = {
  submitForm: () => any;
  getValues: () => any;
};

const BrandForm = memo(
  forwardRef<BrandFormRef, Props>(({ onSubmit: _onSubmit, action }, ref) => {
    const formikRef = useRef<FormikProps<FormValues>>(null);

    useImperativeHandle(ref, () => ({
      submitForm: async () => {
        const validate = await formikRef.current?.submitForm();
        return validate;
      },
      getValues: () => {},
    }));

    const initialValues = useMemo(() => {
      console.log('action :', action);
      return {
        name: undefined,
        sourceUrl: undefined,
        source: undefined,
        ...(action && {
          name: action.name,
          source: action.source,
          sourceUrl: action.sourceUrl,
        }),
      };
    }, [action]);

    return (
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={_onSubmit}
        innerRef={formikRef}
      >
        {({ handleChange, values, errors, touched }) => {
          return (
            <>
              <Form layout="vertical">
                <div className="card">
                  <div className="inputContainer">
                    <Form.Item
                      label="Url"
                      layout="vertical"
                      validateStatus={errors.sourceUrl && touched.sourceUrl ? 'error' : ''}
                      help={errors.sourceUrl && touched.sourceUrl ? errors.sourceUrl : ('' as any)}
                    >
                      <Input
                        name="sourceUrl"
                        value={values.sourceUrl}
                        onChange={handleChange}
                        placeholder="http://..."
                        status={touched.sourceUrl && errors.sourceUrl ? 'error' : ''}
                      />
                    </Form.Item>

                    <div className="flex flex-row">
                      <div className="flex-1">
                        <Form.Item
                          label="Name"
                          layout="vertical"
                          validateStatus={errors.name && touched.name ? 'error' : ''}
                          help={errors.name && touched.name ? errors.name : ('' as any)}
                        >
                          <Input
                            name="name"
                            value={values.name}
                            onChange={handleChange}
                            placeholder="Нэр"
                            status={touched.name && errors.name ? 'error' : ''}
                          />
                        </Form.Item>
                      </div>
                      <div className="w-[13px]" />
                      <div className="flex-1">
                        <Form.Item
                          label="Source"
                          layout="vertical"
                          validateStatus={errors.source && touched.source ? 'error' : ''}
                          help={errors.source && touched.source ? errors.source : ('' as any)}
                        >
                          <Input
                            name="source"
                            value={values.source}
                            onChange={handleChange}
                            placeholder="Source"
                            status={touched.source && errors.source ? 'error' : ''}
                          />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="h-[20px]" />
              </Form>
            </>
          );
        }}
      </Formik>
    );
  })
);

BrandForm.displayName = 'BrandForm';

export { BrandForm };
